import React, { useState, useEffect } from 'react';
import HNavbar from '../../Components/Navbar/HNavbar';
import "../products/products.css";
import MFooter from '../../Components/Main-Footer/MFooter';
import abtsbimg from "../../Assets/abt-sb.png";

function Products() {
    const [showTopBtn, setShowTopBtn] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 400) {
                setShowTopBtn(true);
            } else {
                setShowTopBtn(false);
            }
        };
        window.addEventListener('scroll', handleScroll);

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <>
            <HNavbar />
            {/* ===== HERO ===== */}
            <section className="product-sb-hero">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-xl-5">
                            <div className="product-hero-tag">OUR PRODUCT</div>
                            <h1 className="product-hero-title">
                                PREMIUM ACOUSTIC<br />
                                <span className="orange">SOUND BARRIER</span><br />
                                SYSTEM
                            </h1>
                            <p className="product-hero-desc">
                                Engineered for superior noise reduction and built to withstand the toughest environments.<br />
                                Tested to international standards, Build for long-term performance.
                            </p>

                            <div className="d-flex flex-wrap gap-3 my-3 product-feature-icons-row">
                                {[
                                    {
                                        icon: "fa fa-solid fa-wave-square", label: "Up to 35 dB\nNoise Reduction"
                                    },
                                    { icon: "fa fa-solid fa-shield-halved", label: "Weather & UV\nResistant" },
                                    { icon: "fa fa-solid fa-fire", label: "Fire Retardant\n& Safe" },
                                    { icon: "fa fa-regular fa-clock", label: "Long Life Span\n15+ Years" },
                                ].map((f) => (
                                    <div className="product-feature-icon-item" key={f.label}>
                                        <i className={f.icon}></i>
                                        <span>{f.label}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section >

            {/* ===== PERFORMANCE ===== */}
            < section className="product-performance" >
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-sm-6 col-md-6 order-md-1 order-2">
                            <div className='abtsb-img'>
                                <img src={abtsbimg} alt='sb'></img>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6 order-md-2 order-1">
                            <div className="tech-performance-box">
                                <h5>Technical Performance</h5>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>Noise Reduction (STC)</td>
                                            <td>Up to 35 dB</td>
                                        </tr>
                                        <tr>
                                            <td>Panel Thickness</td>
                                            <td>80mm / 100mm</td>
                                        </tr>
                                        <tr>
                                            <td>Panel Height</td>
                                            <td>500mm – 6000mm (customizable)</td>
                                        </tr>
                                        <tr>
                                            <td>Panel Length</td>
                                            <td>500mm – 3000mm (customizable)</td>
                                        </tr>
                                        <tr>
                                            <td>Material</td>
                                            <td>Acoustic Core</td>
                                        </tr>
                                        <tr>
                                            <td>Surface Finish</td>
                                            <td>PVC Coated</td>
                                        </tr>
                                        <tr>
                                            <td>Fire Performance</td>
                                            <td>className A (ASTM E84)</td>
                                        </tr>
                                        <tr>
                                            <td>Standards</td>
                                            <td>ASTM E90, ISO 10140, BS EN 14388</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </section >

            <section style={{ background: "#f8f8f8" }}>
                <div className='container'>
                    <div className="row">
                        <div className="col-sm-6 col-md-6">
                            <div className="tested-certified-box d-flex flex-column justify-content-center align-items-center">
                                <h5>Tested &amp; Certified</h5>
                                <div className="cert-grid">
                                    <div className="cert-item">
                                        <div className="cert-icon"><i className="fa-solid fa-certificate"></i></div>
                                        <div className="cert-text">
                                            <strong>ASTM E90</strong>
                                            <span>Sound Transmission Class</span>
                                        </div>
                                    </div>
                                    <div className="cert-item">
                                        <div className="cert-icon"><i className="fa-solid fa-shield-halved"></i></div>
                                        <div className="cert-text">
                                            <strong>ISO 10140</strong>
                                            <span>Sound Insulation Testing</span>
                                        </div>
                                    </div>
                                    <div className="cert-item">
                                        <div className="cert-icon"><i className="fa-solid fa-fire"></i></div>
                                        <div className="cert-text">
                                            <strong>ASTM E84</strong>
                                            <span>Fire Performance Class A</span>
                                        </div>
                                    </div>
                                    <div className="cert-item">
                                        <div className="cert-icon"><i className="fa-solid fa-road"></i></div>
                                        <div className="cert-text">
                                            <strong>BS EN 14388</strong>
                                            <span>Acoustic Barriers for Roads &amp; Railways</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6 d-flex flex-column align-items-center mt-4">
                            <h5 className='key-benefits'>Key benefits</h5>
                            <div className='kb d-flex flex-column gap-2'>
                                {["High acoustic performance (STC up to 35 dB)", "Durable & weather resistant", "Fire retardant & compliant to global standards", "Low maintenance", "Sustainable & recyclable", "Tested in accordance with international standards"].map((item) => (
                                    <div className="challenge-item" key={item}>
                                        <i className="fa fa-check-circle"></i>
                                        <span>{item}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="btns m-5">
                <div className="container">
                    <div className="d-flex flex-wrap justify-content-center align-items-center gap-2 mt-2">
                        <a href="/" className="btn2 btn2-outline-dark-sb d-inline-flex align-items-center gap-2">
                            DOWNLOAD BROCHURE&nbsp;<i className="fa fa-download"></i>
                        </a>
                        <a href="/" className="btn2 btn2-orange d-inline-flex align-items-center gap-2">
                            REQUEST A QUOTE&nbsp;<i className="fa fa-arrow-right"></i>
                        </a>
                        <a href="/contact" className="btn2 btn2-orange d-inline-flex align-items-center gap-2">
                            CONTACT US&nbsp;<i className="fa fa-phone" style={{ color: "white" }}></i>
                        </a>
                    </div>
                </div>
            </section>
            {
                showTopBtn && (
                    <button className='scroll-to-top'
                        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                    > ↑ </button>
                )
            }
            <MFooter />
        </>
    )
}

export default Products